import React, { useState, useEffect } from 'react';
import { Dialog, Divider } from '@mui/material';
import pdfIcon from 'assets/img/svg/pdfIcon.svg';
import fileIcon from 'assets/img/svg/DocumentLight.svg';
import DownloadIcon from 'assets/img/svg/downloadIcon.svg';
import { ReactComponent as EyeIcon } from 'assets/img/svg/eye_open.svg';
import closeIcon from 'assets/img/svg/closeSquare.svg';
import moment from 'moment';
import { fetchAllPostPromisedData ,fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from 'views/pages/manage/common/constant';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';

export const viewDocument = async (s3Key, action ="VIEW") => {

  try {
    const response = await fetchAllPostPromisedData(
      `${endpoint.fetchS3Url.getDownloadUrl}?key=${s3Key}`,
      true
    );

    if (response?.code === 200) {
      window.open(response.data.url, '_blank');
    } else {
      failureToast(`Unable to ${action.toLowerCase()} file.`);
    }
  } catch (error) {
    console.error(error);
    failureToast('Something went wrong while fetching file.');
  } finally {
  }
};




const DocumentViewerDialog = ({ id , status}) => {
  console.log("status",status)
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [actionType, setActionType] = useState(null);

  // Fetch document list from backend
  const getDocuments = async (applicationOtherChargeId) => {
    try {
      const url = endpoint.otherChargesDocument?.get;

      setLoading(true);
      const response = await fetchAllPromisedData(
        `${url}/${applicationOtherChargeId}`);
      if (response) {
        setDocuments(response || []);
      } else {
        failureToast('Failed to fetch documents.');
      }
    } catch (err) {
      console.error(err);
      failureToast('Error fetching documents.');
    } finally {
      setLoading(false);
    }
  };
  const deleteDocument = async(currentId)=>{
    const url  = endpoint.otherChargesDocument.deleteFile
    if(!url) return ;
   const response = await fetchAllPostPromisedData(`${url}/${currentId}`, {}, 'DELETE');
    if (response?.code === 200) {
      successToast("File deleted successfully!");
      getDocuments(id)
    } else {
      failureToast("Failed to save file metadata.");
    }
  }

  // Fetch docs when dialog opens
  useEffect(() => {
    if (open && id) getDocuments(id);
  }, [open, id]);

  // View or Download a file
  const getFileUrl = async (index, action) => {
    setLoadingIndex(index);
    setActionType(action);

    const file = documents[index];
    try {
      const response = await fetchAllPostPromisedData(
        `${endpoint.fetchS3Url.getDownloadUrl}?key=${file?.s3Key}`,
        true
      );

      if (response?.code === 200) {
        window.open(response.data.url, '_blank');
      } else {
        failureToast(`Unable to ${action.toLowerCase()} file.`);
      }
    } catch (error) {
      console.error(error);
      failureToast('Something went wrong while fetching file.');
    } finally {
      setLoadingIndex(null);
      setActionType(null);
    }
  };

  return (
    <>
      {/* 👁️ View Icon Trigger */}
      <div
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
        onClick={() => setOpen(true)}
      >
        <span style={{ color: '#00B0F5', fontWeight: 600 }}>View</span>
      </div>

      {/* 📄 Documents Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          '& .MuiPaper-root': {
            boxShadow: '0px 0px 9px 0px rgba(0,0,0,0.5)',
            width: 380,
            borderRadius: '10px',
          },
        }}
      >
        <div className="p-3">
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="label-color large-text pb-2" style={{ fontWeight: 600, fontSize: 16 }}>
              Documents
            </div>
            <div style={{ cursor: 'pointer' }} onClick={() => setOpen(false)}>
              <img src={closeIcon} alt="close" />
            </div>
          </div>

          <Divider sx={{ marginTop: 1, marginBottom: 1 }} />

          {/* Loading or Empty State */}
          {loading ? (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <i className="fas fa-spinner fa-spin" /> Loading documents...
            </div>
          ) : documents.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '20px 0', color: '#757575' }}>
              No documents found.
            </div>
          ) : (
            <div
              className="scroll-overlay"
              style={{
                marginTop: 10,
                marginBottom: 20,
                maxHeight: '250px',
                overflowY: 'auto',
                paddingRight: '10px',
              }}
            >
              <div
                className="label-color regular-bolder mb-2"
                style={{ fontSize: 13, fontWeight: 600 }}
              >
                Saved documents
              </div>

              {(documents ?? []).map((file, index) => (
                <div
                  key={file.id}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '10px',
                  }}
                >
                  {/* File Info */}
                  <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                    <div style={{ width: 40, height: 40 }}>
                      <img
                        src={
                          file?.fileName?.split('.')?.[1] === 'pdf'
                            ? pdfIcon
                            : fileIcon
                        }
                        width="100%"
                        height="100%"
                        alt="file icon"
                      />
                    </div>
                    <div>
                      <div
                        style={{
                          color: '#0F0F0F',
                          fontSize: 12,
                          width: '140px',
                          wordWrap: 'break-word',
                        }}
                      >
                        {file.fileName}
                      </div>
                      <div style={{ color: '#757575', fontSize: 10 }}>
                        Uploaded on {moment(file.createdOn).format('DD MMM YYYY')}
                      </div>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                    {loadingIndex === index && actionType === 'VIEW' ? (
                      <i className="fas fa-spinner fa-spin" aria-hidden="true" />
                    ) : (
                      <div
                        onClick={() => getFileUrl(index, 'VIEW')}
                        style={{ cursor: 'pointer' }}
                      >
                        <EyeIcon />
                      </div>
                    )}
                   {!['APPROVED', 'PAID'].includes(status) && <i className="fas fa-trash" onClick={()=>deleteDocument(file.id)}/>}

                    {loadingIndex === index && actionType === 'DOWNLOAD' ? (
                      <i className="fas fa-spinner fa-spin" aria-hidden="true" />
                    ) : (
                      <div
                        onClick={() => getFileUrl(index, 'DOWNLOAD')}
                        style={{ cursor: 'pointer' }}
                      >
                        <img src={DownloadIcon} alt="download" />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default DocumentViewerDialog;
